define(["exports", "./utils", "hyperhtml"], function (_exports, _utils, _hyperhtml) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.run = run;
  _exports.name = void 0;
  _hyperhtml = _interopRequireDefault(_hyperhtml);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  function _templateObject() {
    const data = _taggedTemplateLiteral(["\n      <a href=\"", "\" class=\"self-link\" aria-label=\"\xA7\"></a>\n    "]);

    _templateObject = function _templateObject() {
      return data;
    };

    return data;
  }

  function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

  // @ts-check
  // Module core/id-headers
  // All headings are expected to have an ID, unless their immediate container has one.
  // This is currently in core though it comes from a W3C rule. It may move in the future.
  const name = "core/id-headers";
  _exports.name = name;

  function run(conf) {
    /** @type {NodeListOf<HTMLElement>} */
    const headings = document.querySelectorAll("section:not(.head):not(.introductory) h2, h3, h4, h5, h6");

    for (const h of headings) {
      (0, _utils.addId)(h);
      if (!conf.addSectionLinks) continue;
      const id = h.parentElement.id || h.id;
      h.appendChild((0, _hyperhtml.default)(_templateObject(), "#".concat(id)));
    }
  }
});
//# sourceMappingURL=id-headers.js.map